module.exports = __webpack_public_path__ + "img/renaissance_educator_academy_logo.e4368d56.svg";